import styles from './Nav.module.css';

type NavProps = {
	isInvited: boolean;
	showLogout?: boolean;
	onAuth: () => void;
	onLogout?: () => void;
	onWaitlist: () => void;
};

export const Nav = ({
	isInvited,
	showLogout,
	onAuth,
	onLogout,
	onWaitlist,
}: NavProps) => {
	const renderRightButton = () => {
		if (isInvited && showLogout) {
			return (
				<button type="button" className={styles.authBtn} onClick={onLogout}>
					Sign out
				</button>
			);
		}
		if (isInvited) {
			return (
				<button type="button" className={styles.authBtn} onClick={onAuth}>
					<span className={styles.authBtnLabel}>
						Sign In
						<span className={styles.authBtnExtra}> with Adobe</span>
					</span>
					<span aria-hidden="true" className={styles.arrow}>
						→
					</span>
				</button>
			);
		}
		return (
			<button type="button" className={styles.authBtn} onClick={onWaitlist}>
				<span className={styles.authBtnLabel}>Join Waitlist</span>
				<span aria-hidden="true" className={styles.arrow}>
					→
				</span>
			</button>
		);
	};

	return (
		<nav className={styles.nav}>
			<div className={styles.inner}>
				<button
					type="button"
					className={styles.brand}
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
				>
					<span className={styles.mark} aria-hidden="true">
						Bw
					</span>
					<span className={styles.wordmark}>
						<strong>Project Bridgeway</strong> by Adobe
					</span>
				</button>
				<div className={styles.right}>{renderRightButton()}</div>
			</div>
		</nav>
	);
};
